module.exports = __webpack_public_path__ + "static/media/Shox 03 BG 01.44c17acc.png";